import { AccountService } from './../../service/account.service';
import { ActionLogForOffer } from './../../model/action-log-for-offer.model';
import { Component, OnInit, Input } from '@angular/core';
import { MailInfo } from '../../model/mail-info.model';
import { MatchingOffer } from '../../model/matching-offer.model';
import { OfferService } from '../../service/offer.service';
import { HttpInterceptingHandler } from '@angular/common/http/src/module';

@Component({
  selector: 'app-offer-action-user',
  templateUrl: './offer-action-user.component.html',
  styleUrls: ['./offer-action-user.component.scss']
})
export class OfferActionUserComponent implements OnInit {
  @Input() actionLog: ActionLogForOffer;
  @Input() matchingOffer: MatchingOffer;
  @Input() mailInfo: MailInfo;
  @Input() mailType: string;
  constructor(
    // ↓ htmlテンプレートで使用中
    private offerService: OfferService,
    public accountService: AccountService
  ) {}

  ngOnInit() {}

  showConfirmUserId(): string {
    if (this.mailType === 'project') {
      return this.actionLog.project_confirm_user_id;
    } else {
      return this.actionLog.worker_confirm_user_id;
    }
  }

  showApproveUserId(): string {
    if (this.mailType === 'project') {
      return this.actionLog.project_approve_user_id;
    } else {
      return this.actionLog.worker_approve_user_id;
    }
  }

  actionLogTime(action: string): Date {
    switch (action) {
      case 'mail_confirm':
        return this.mailType === 'project'
          ? this.actionLog.project_confirm_from_offer_time
          : this.actionLog.worker_confirm_from_offer_time;
      case 'approve':
        return this.mailType === 'project'
          ? this.actionLog.project_approve_time
          : this.actionLog.worker_approve_time;
      case 'interviewing':
        const project_approve_time = new Date(
          this.actionLog.project_approve_time
        );
        const worker_approve_time = new Date(
          this.actionLog.worker_approve_time
        );
        return project_approve_time > worker_approve_time
          ? project_approve_time
          : worker_approve_time;
      case 'contract_established':
        return this.actionLog.contract_established_time
      case 'cancel':
        return this.actionLog.cancel_time
    
      default:
        break;
    }
  }
  // 「成立」「不成立」「取消」のいずれかであるか判定
  //  成立・不成立・取消 の3つは、回答待ちや承諾などの他のステータスより優先される。
  //  また、この3つは同時には発生し得ないので、この3つの間での優劣は考慮不要
  contract_established_or_cancel(): boolean {
    return this.offerService.isCancelled(this.matchingOffer) ||
           this.offerService.isSucceeded(this.matchingOffer) ||  
           this.offerService.isFailed(this.matchingOffer);
  }
}
